import { PageLoading } from '@/components/page-loading'
import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import { Modal } from 'antd'
import { SignTitle, SvgIcon } from '@/components'

import DataProtectionCreate from '@/pages/data-protection/create-task'
import DataProtectionTask from '@/pages/data-protection/task-list'
import DataProtectionTaskDetail from '@/pages/data-protection/task-detail'
import DataProtectionTemplate from '@/pages/data-protection/template-resources'
import { t } from '@/i18n'

export const DataProtectionLayout = () => {
  const [isShow, setIsShow] = useState(false)

  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <DataProtectionCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <DataProtectionTask />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <DataProtectionTaskDetail />,
      show: false,
      name: 'detail',
    },
    {
      key: 'template',
      label: t('自定义模板'),
      component: <DataProtectionTemplate />,
    },
  ]

  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <Modal
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        visible={isShow}
        onCancel={onHide}
        footer={null}
        centered
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('可验证设备类型')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t('网络DLP、终端DLP等各类数据防泄漏设备。')}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '基于算法规则模拟生成企业敏感数据，利用客户端通过邮件、HTTP、HTTPS等不同通信协议模拟数据外泄行为，通过比对目标接收文件及客户端执行日志，以验证设备的数据安全能力有效性。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('创建任务前需部署客户端。')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span> {t('基于规则模拟生成企业敏感数据，不触及企业真实敏感数据。')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t('内置丰富模板，支持模板自定义，支持用户自定义敏感数据动态变量和敏感数据载体')}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('支持外泄文件压缩嵌套，支持HTTP、HTTPS、Git等外泄途径。')}</span>
          </div>
        </div>
      </Modal>
    </>
  )
}
